import { render, staticRenderFns } from "./findportal.vue?vue&type=template&id=b8c50358&"
import script from "./findportal.vue?vue&type=script&lang=js&"
export * from "./findportal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {FindHeader: require('/home/runner/work/Detected-Profile-Portal-Frontend/Detected-Profile-Portal-Frontend/web/components/FindHeader.vue').default,CommonScreenSizeAlert: require('/home/runner/work/Detected-Profile-Portal-Frontend/Detected-Profile-Portal-Frontend/web/components/Common/ScreenSizeAlert.vue').default})
